import { render, staticRenderFns } from "./CustomerImportList.vue?vue&type=template&id=5baee0c2&scoped=true&"
import script from "./CustomerImportList.vue?vue&type=script&lang=ts&"
export * from "./CustomerImportList.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerImportList.vue?vue&type=style&index=0&id=5baee0c2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baee0c2",
  null
  
)

export default component.exports